function Search_algolia_autocomplete(element) {
  this.loaded = false;
  this.algoliaSearchVersion = element.dataset.algoliaSearchVersion;
  this.algoliaAutocompleteVersion = element.dataset.algoliaAutocompleteVersion;

  /**
   * init decorator
   */
  this.init = function() {
    // console.log("Search_algolia_autocomplete init...");

    if (!this.loaded) {
      this.loadAlgoliaLibraries();
    }

    this.loaded = true;
  };


  /**
   * inject remote CDN scripts used for algolia autocomplete search client
   */
  this.loadAlgoliaLibraries = function () {
    var algoliasearch = document.createElement('script');
    algoliasearch.type = 'text/javascript';
    algoliasearch.async = false;
    algoliasearch.src = 'https://cdn.jsdelivr.net/algoliasearch/' + this.algoliaSearchVersion + '/algoliasearch.min.js';

    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(algoliasearch, s);

    var autocomplete = document.createElement('script');
    autocomplete.type = 'text/javascript';
    autocomplete.async = false;
    autocomplete.src = 'https://cdn.jsdelivr.net/autocomplete.js/' + this.algoliaAutocompleteVersion + '/autocomplete.min.js';

    s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(autocomplete, s);
  };
}
